<template>
    <div class="container page">
        <van-nav-bar :title="$t('acordertit')" class="nav-bar" fixed>
            <template #left>
                <van-icon name="arrow-left" color="#fff" @click="back()" />
            </template>
        </van-nav-bar>
        <div class="latestbox">
            <div class="latestitem" v-for="v in list" :key="v.id">
                <div>
                    <img src="@/assets/avatar.png" style="width: 50px; border-radius: 50%;">
                    <div>
                        <div>{{ hideUserName(v.username) }}</div>
                        <div>{{ new Date(v.addtime *
                            1000).toLocaleDateString().replace(/\//g, "-")
                            + " " + new
                                Date(v.addtime * 1000).toTimeString().substr(0, 8) }} {{ $t('goumaile') }}</div>
                    </div>
                </div>
                <div>
                    <img :src="v.goods_pic">
                    <div>
                        <div class="van-multi-ellipsis--l2">{{ v.goods_name }}</div>
                        <div><van-rate v-model="rate" void-color="#fff" readonly size="15" /></div>
                        <div>
                            <span>{{ $t('MAD') }} {{ v.price2 }}</span>
                            <span>×{{ v.num }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "MallOrder",
    data() {
        return {
            rate: 5,
            list: [],
        }
    },
    mounted() {
        this.$httpNew({
            method: 'get',
            data: {},
            url: 'aichao_order_all'
        }).then(res => {
            if (res.code == 0) {
                this.list = res.data || [];
            } else {
                this.list = [];
            }
        })
    },
    methods: {
        back() {
            return window.history.back();
        },
        hideUserName(text) {
            if (!text) return '';
            // 如果是纯数字且长度 >= 7，当作电话号码处理
            if (/^\d{7,}$/.test(text)) {
                return text.slice(0, 3) + '****' + text.slice(-4);
            }
            // 昵称处理
            const len = text.length;
            if (len === 1) {
                return text;
            }
            if (len === 2) {
                return text[0] + '*';
            }
            if (len <= 4) {
                return text[0] + '*'.repeat(len - 2) + text[len - 1];
            }
            // 5 个字符及以上，保留前2后2
            return text.slice(0, 2) + '*'.repeat(len - 4) + text.slice(-2);
        },
    }
}
</script>

<style lang='less' scoped>
.latestbox {
    padding: 120px 12px 12px;
    background: #f2f2f2;
    height: calc(100vh - 120px);
    overflow: auto;

    .latestitem {
        padding: 12px;
        border-radius: 10px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
        margin-bottom: 10px;
        background: #fff;

        >div:nth-child(1) {
            display: flex;
            align-items: center;
            margin-bottom: 20px;

            >img {
                margin-right: 10px;
            }

            >div {
                >div:last-child {
                    font-size: 14px;
                    color: #9e9e9e;
                    margin-top: 5px;
                }
            }
        }

        >div:nth-child(2) {
            display: flex;
            align-items: center;

            >img {
                width: 180px;
                height: 180px;
                object-fit: cover;
                border-radius: 10px;
                margin-right: 10px;
            }

            >div {
                width: calc(100% - 200px);

                >div:nth-child(2) {
                    margin: 10px 0;
                }

                >div:nth-child(3) {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;

                    span:first-child {
                        color: #ee0a24;
                        font-weight: bold;
                    }

                    span:last-child {
                        color: #9e9e9e;
                    }
                }
            }
        }
    }
}
</style>